/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import { flash } from 'react-animations';
import styled, { keyframes } from 'styled-components';
import { HashLink } from 'react-router-hash-link';
import { nettoyerObjetEmail, fromNow } from '../../App_Code/Utils';
import { obtenirMemoMessage, obtenirPrestation } from '../../App_Code/API';
import SensCommunication from '../../App_Data/SensCommunication';
import IconeBureau from '../../App_Data/IconeBureau';
// import SelecteurDate from '../SelecteurDate';
import Card, { LigneCard } from '../Card';
// import EtatTicket from './EtatTicket';

const Notif = styled.div`animation: 3.5s ${keyframes`${flash}`} infinite`;

const Icone = ({path, couleur}) => (
    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={25} height={25} style={{ filter: 'invert(1)' }}>
        <image xlinkHref={path} width={25} height={25}/>
    </svg>
);

class Ticket extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Memo : "...",
            Prest: '',
        };
    }

    componentDidMount() {
        const { affaire, NumAuto, Prest } = this.props;
        // obtenirMemoMessage(affaire.length > 1 ? affaire[0].NumAuto : NumAuto).then((memo) => {
        //     this.setState({ Memo: memo });
        // });
        obtenirPrestation(affaire.length > 1 ? affaire[0].Prest : Prest).then((prest) => {
            this.setState({ Prest: prest });
        });
    }

    render() {
        const { Prest } = this.state;
        const {
            DateSaisie, NumAff, NumAuto, Objet, SensCom, Bureau, LibBureau, LibPrest, Memo, affaire, nonLu, actions,
        } = this.props;
        const sensCom = SensCommunication(affaire.length > 1 ? affaire[0].SensCom : SensCom)

        return (
            <HashLink
                className="unlink"
                to={{
                    pathname: '/MaMessagerie/Conversation',
                    state: { NumAff },
                    // hash: affaire.length > 1 ? `#${affaire.length}` : '',
                }}
                onClick={() => actions.mesMarquerVuParClient(NumAuto)}
            >
                <Card className="card-hover" styleCss={nonLu > 0 ? { boxShadow: '1px 1px 10px #dc3545' } : null}>
                    <div className="row d-flex align-items-center">
                        <div className="col-2 col-xl-1">
                            <IconeBureau idBureau={Bureau} taille={"fa-3x"} title={LibBureau} />
                        </div>
                        <div className="col-9 col-xl-10">
                            <div className="row d-flex">
                                {Prest && Prest.Icone ?
                                    <div className="d-flex align-items-center justify-content-center align-middle" title={LibPrest} style={{ height: 28, width: 28, borderRadius: '50%', backgroundColor: Prest.Couleur }}>
                                        <Icone path={Prest.Icone} couleur={Prest.Couleur} /> {" "}
                                    </div> :
                                    <div className="d-flex align-items-center justify-content-center" style={{ height: 28, width: 28, color: "#6c757d" }} title={LibPrest}>
                                        <svg width="25" height="25" viewBox="0 0 16 16" className="bi bi-question-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                            <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z" />
                                        </svg>
                                    </div>
                                }
                                <h4 className="col-11 w-100 d-inline-block text-truncate">
                                    {nettoyerObjetEmail(Objet)}
                                </h4>
                            </div>
                            <span className="text-muted font-italic">
                                {'"Dernier message'}{' '}
                                <i className={sensCom.Icone} title={sensCom.Type} />{' '}
                                {' '}{fromNow(affaire.length > 1 ? affaire[0].DateSaisie : DateSaisie, 'DD/MM/YYYY HH:mm')}
                            </span>
                        </div>
                        <div className="col-1 col-xl-1">
                            <div className="d-flex align-items-center justify-content-end">
                                <div className="d-flex flex-column">
                                    {nonLu > 0 ?
                                        <Notif>
                                            <span className="ml-3 fa-stack fa-1x" title={nonLu > 1 ? `${nonLu} nouveaux messages` : `${nonLu} nouveau message`}>
                                                <i className="fas fa-circle fa-stack-2x text-danger" />
                                                <strong className="fa-stack-1x fa-stack-text text-light">{nonLu}</strong>
                                            </span>
                                        </Notif> : null
                                    }
                                    <span className="ml-3 fa-stack fa-1x" title={affaire.length > 1 ? `contient ${affaire.length} messages` : `contient ${affaire.length} message`}>
                                        <i className="fas fa-comment fa-stack-2x text-primary" />
                                        <strong className="fa-stack-1x fa-stack-text text-light">{affaire.length}</strong>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div>
                        <p className="card-text font-italic" title={Memo}>
                            <span className="w-100 d-inline-block text-truncate">{Memo}</span>
                        </p>
                        <span className={`btn ${nonLu > 0 ? 'btn-danger' : 'btn-primary'}`}>
                            {nonLu > 1 ? 'Voir les nouveaux messages'
                                : nonLu > 0 ? 'Voir le nouveau message' : 'Voir la conversation'}
                        </span>
                    </div>
                </Card>
            </HashLink>
        );
    }
}
Ticket.displayName = 'Ticket';


export default Ticket;



// WEBPACK FOOTER //
// ./src/components/MaMess/Ticket.js